import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button, Modal, Text } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as sizeWithoutStockModalStyle } from "./SizeWithoutStockModal.style";

interface SizeWithoutStockModalProps {
  readonly visible: boolean;
  readonly onDismiss: () => void;
}
const SizeWithoutStockModal: FC<SizeWithoutStockModalProps> = ({ visible, onDismiss }) => {
  const titleText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.SIZE_WITHOUT_STOCK_MODAL_TITLE });
  const descriptionText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.SIZE_WITHOUT_STOCK_MODAL_DESCRIPTION });
  const buttonText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.SIZE_WITHOUT_STOCK_MODAL_BUTTON });

  const style = useMemo(() => sizeWithoutStockModalStyle(), []);

  return (
    <Modal portalHostName="Checkout" visible={visible} showCloseButton onClose={onDismiss}>
      <View style={style.modalContent}>
        <Text level={3} style={style.title} variant="heading">
          {titleText}
        </Text>
        <Text level={3} style={style.description}>
          {descriptionText}
        </Text>
        <Button onPress={onDismiss}>{buttonText}</Button>
      </View>
    </Modal>
  );
};

export { SizeWithoutStockModal };
